module.exports = __webpack_public_path__ + "custom-config/img/tv_qrcode.961f7d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tv/assets/img/tv_qrcode.png
// module id = B8lz
// module chunks = 2 3 4 6 7 8 9